export default {
  switch: 'プロダクトを選択',
  accountCenter: 'アカウントセンター',
  interviewInvitation: '面接招待',
  companyManagement: '企業管理',
  error403: 'アクセス権限なし',
  error404: 'ページが見つかりません',
  termsOfService: '利用規約',
  login: 'ログイン',
  forgotPassword: 'パスワード再設定',
  resetPassword: 'パスワード再設定'
};
